import React from 'react';
import Fade from 'react-reveal/Fade';

const HistoryCard = () => {
  return (
    <div>
       <Fade left>
        <a href="https://www.sefalane.com/p/mobile-app/"><img src="https://www.sefalana.com/data/85c7731f1ce364c50c3e941b9e4f9e97.jpg"  className="mx-auto top-12 bottom-5 w-11/12"/></a>
      </Fade>
    </div>
  )
}

export default HistoryCard
